import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'milhar',
})
export class MilharPipe implements PipeTransform {
    transform(value: number): unknown {
        const auxiliar = value.toLocaleString('pt-BR');
        parseInt(auxiliar);
        return auxiliar;
    }
}
